export default __webpack_public_path__ + "static/media/devfinder-preview.d9dbba44.png";